import React from 'react'
import {useLocation} from 'react-router'
import ContainerAtom from '../../@atoms/to_layout/container/container.atom'
import utils from '../../utils'

const AppContentAreaComponent = function ({...props}) {
  const location = useLocation()
  const isTransparentBg = location.pathname === '/login'
  return (
    <ContainerAtom ap_type="app_content_area_wrapper">
      <ContainerAtom
        ap_type="app_content_area"
        className={utils.classnames({transparent: isTransparentBg})}
        {...props}
      />
    </ContainerAtom>
  )
}

export default AppContentAreaComponent
